import { render, staticRenderFns } from "./VueDropzone.vue?vue&type=template&id=5cc800d3"
import script from "./VueDropzone.vue?vue&type=script&lang=js"
export * from "./VueDropzone.vue?vue&type=script&lang=js"
import style0 from "./VueDropzone.vue?vue&type=style&index=0&id=5cc800d3&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cc800d3')) {
      api.createRecord('5cc800d3', component.options)
    } else {
      api.reload('5cc800d3', component.options)
    }
    module.hot.accept("./VueDropzone.vue?vue&type=template&id=5cc800d3", function () {
      api.rerender('5cc800d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VueDropzone/VueDropzone.vue"
export default component.exports